import api from "./api";

export interface UploadResponse {
  success: boolean;
  imageUrl: string;
  message: string;
}

class UploadService {
  async uploadImage(file: File): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post<UploadResponse>("/upload/image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  }
}

export const uploadService = new UploadService();